<template>
  <div>
    <PageTitle :main="$t('gestao-de-analises')" sub imagem="dashboard.png" />
    <vue-table-dynamic
      class="table-analysis"
      :params="params"
      @row-click="onRowClick"
    >
      <template v-slot:column-0="{ props }">
        <span class="cell--slot-0"> {{ props.row }} </span>
      </template>
    </vue-table-dynamic>
    <b-modal id="AnalysisDetails" size="xl" hide-footer>
      <div slot="modal-title" class="img-slot">
        <img
          style="width: 33px; height: 33px; margin-right: 10px"
          src="@/assets/circular138.png"
          alt="salvar_analise"
        />
        {{ $t('editor-de-analise') }} </div>
      <AnalysisDetails :analysisSelected="analysisSelected"></AnalysisDetails>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
// import * as moment from 'moment'
import PageTitle from "@/components/template/PageTitle.vue";
import { WaitMixin } from "../mixins/waitMixin";
import { FiltersMixin } from "../mixins/filtersMixin";
import AnalysisDetails from "./AnalysisDetails.vue";

// eslint-disable-next-line no-unused-vars
import { urlMainAPI, defaultSuccess, onEventBuss } from "@/global";

export default {
  name: "AnalysisGrid",

  components: { PageTitle, AnalysisDetails },
  mixins: [WaitMixin, FiltersMixin],

  watch: {},

  data() {
    return {
      allAnalysisList: [],
      analysisSelected: {},
      params: {
        data: [
          [this.$t('id'), this.$t('data'), this.$t('produto-0'), this.$t('processo'), this.$t('equipamento'), this.$t('grandezas-0')],
        ],
        header: "row",
        border: true,
        stripe: true,
        sort: [0, 1, 2, 3, 4, 5],
        enableSearch: true,
        pagination: true,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        filter: [],
        columnWidth: [
          { column: 0, width: "3%", isEditable: false },
          { column: 1, width: "9%", isEditable: false },
          { column: 2, width: "20%", isEditable: false },
          { column: 3, width: "20%", isEditable: false },
          { column: 4, width: "21%", isEditable: false },
          { column: 5, width: "27%", isEditable: false },
        ],
      },
    };
  },

  methods: {
    async loadAnalysis() {
      defaultSuccess(this.$t('carregando-analises'));
      this.wait = true;

      const url = `${urlMainAPI}/getgreatnessforanalysisdata`;
      await axios
        .get(url)
        .then((res) => {

          let DataToOrder = res.data;
        
          DataToOrder.forEach(i => {
            i.analysisTimestamp = new Date(i.analysisTimestamp)
          })


          DataToOrder.sort((a, b) => b.analysisTimestamp - a.analysisTimestamp);

          DataToOrder = DataToOrder.map((dataToStr) => {

          const dtObj = new Date(dataToStr.analysisTimestamp);

          let dateFormat = ("0" + dtObj.getDate()).slice(-2);
          let monthFormat = ("0" + (dtObj.getMonth() + 1)).slice(-2);
          let hourFormat = ("0" + dtObj.getHours()).slice(-2);
          let minuteFormat = ("0" + dtObj.getMinutes()).slice(-2);
          let secondFormat = ("0" + dtObj.getSeconds()).slice(-2);

          const formattedString = `${dtObj.getFullYear()}/${monthFormat}/${dateFormat} ${hourFormat}:${minuteFormat}:${secondFormat}`;

          dataToStr.analysisTimestamp = formattedString;

          return dataToStr;
        });

          this.allAnalysisList = DataToOrder;

          if (res.data.length > 0) {
            this.buildAnalysisGrid();
            defaultSuccess(this.$t('analises-carregadas'));
          } else defaultSuccess(this.$t('nao-ha-dados-para-serem-exibidos'));
          this.wait = false;
        })
        .catch((e) => {
          console.log(e);
          this.wait = false;
        });
    },

    buildAnalysisGrid() {
      this.params.data.splice(1);
      this.params.filter = [];
      this.allAnalysisList.forEach((o) => {
        this.setFilter(o);
        this.params.data.push(this.getRow(o));
      });
    },

    async setFilter(analysis) {
      for (let i = 1; i < 6; i++) {
        let filterFounded = this.params.filter.find((f) => f.column == i);
        if (filterFounded) {
          let obj = this.getObjectColumn(analysis, i);

    
          let contentFinded = filterFounded.content.find((c) =>
            c.value.includes(obj.value)
          );
          if (!contentFinded) filterFounded.content.push(obj);
        } else {
          this.params.filter.push({
            column: i,
            content: [this.getObjectColumn(analysis, i)],
            method: (value, tableCell) => tableCell.data == value,
          });
        }
      }
    },

    getObjectColumn(analysis, i) {
      if (i == 1)
        return {
          text: analysis.analysisTimestamp,
          value: analysis.analysisTimestamp,
        };

      if (i == 2) return { text: analysis.product, value: analysis.product };

      if (i == 3) return { text: analysis.process, value: analysis.process };

      if (i == 4)
        return { text: analysis.equipment, value: analysis.equipment };

      if (i == 5) return { text: analysis.name, value: analysis.name };
    },

    onRowClick(indice) {
      if (this.clickedOnTable && indice != 0) {
        let analysis = this.allAnalysisList[indice - 1];
        if (analysis) {
          this.analysisSelected = {
            productId: analysis.productId,
            processId: analysis.processId,
            equipmentId: analysis.equipmentId,
            analysisTimestamp: analysis.analysisTimestamp,
          };
          this.$bvModal.show("AnalysisDetails");
        }
      } else {
        this.clickedOnTable = true;
        this.dbClickTimer();
      }
    },

    getRow(a) {
      return [
        `${a.productId}-${a.processId}-${a.equipmentId}-${a.analysisTimestamp}`,

        a.analysisTimestamp,
        a.product,
        a.process,
        a.equipment,
        a.name,
       
      ];
    },

    dbClickTimer() {
      setTimeout(() => {
        this.clickedOnTable = false;
      }, 400);
    },

    setLanguage() {
      let Search = this.$t('pesquisar-0');
      let page = this.$t('pagina');

      document.querySelector(".tools-search>input").placeholder = Search;
      let text = document.querySelector(".pagination-size>span").innerHTML;

      document.querySelector(".pagination-size>span").innerHTML = text.replace(
        "page",
        page
      );

      document
        .querySelectorAll(".pagination-size>div>.size-item")
        .forEach((el) => {
          el.onclick = (event) => {
            document.querySelector(".pagination-size>span").innerHTML =
              event.target.innerHTML;
          };

          let text = el.innerHTML;
          el.innerHTML = text.replace("page", page);
        });
    },

    setLanguageFilter() {
      let reset = this.$t('resetar-0');
      let confirm = this.$t('confirmar-0');

      setTimeout(() => {
        document.querySelectorAll("span.filter-btns").forEach((el) => {
          el.innerHTML = reset;
        });

        document
          .querySelectorAll("span.filter-btns.do-filter")
          .forEach((el) => {
            el.innerHTML = confirm;
          });
      }, 100);
    },
  },

  async created() {
    await this.loadAnalysis();
  },

  async mounted() {
    this.setLanguage();
    this.setLanguageFilter();
    onEventBuss("reloadGridAnalysis", this.loadAnalysis);
  },

  destroyed() { this.wait = false },
};
</script>

<style>
.table-analysis
  > div
  > div
  > div
  > div
  > div
  > span
  > span
  > div
  > .filter-content {
  top: 200px !important;
  overflow-y: scroll;
  max-height: 350px;
}
</style>

<style scoped>
.table-analysis {
  cursor: pointer;
}
</style>

